// extracted by mini-css-extract-plugin
export default {"link":"UserPanel_link__1F7t5"};